import { render } from "./UdstPage.vue?vue&type=template&id=6f262164"
import script from "./UdstPage.vue?vue&type=script&lang=js"
export * from "./UdstPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__